/**
 * Collapsible List functionality for mobile
 * Shows first 5 list items, hides the rest with show more/less toggle
 */

class CollapsibleList {
  constructor() {
    this.initializedWrappers = new Set();
    this.init();
  }

  init() {
    const wrappers = document.querySelectorAll('.collapsible-list-wrapper:not([data-initialized])');
    
    wrappers.forEach(wrapper => {
      // Mark as initialized to prevent duplicate handlers
      wrapper.setAttribute('data-initialized', 'true');
      
      const content = wrapper.querySelector('.collapsible-list-content');
      const toggle = wrapper.querySelector('.collapsible-list-toggle');
      
      if (!content || !toggle) return;

      // Find all ul elements within the content
      const lists = content.querySelectorAll('ul');
      let hasLongList = false;
      
      lists.forEach(list => {
        const items = list.querySelectorAll('li');
        
        if (items.length > 5) {
          hasLongList = true;
          // Hide items beyond the 5th on mobile
          items.forEach((item, index) => {
            if (index >= 5) {
              item.classList.add('collapsible-list-item-hidden');
            }
          });
        }
      });
      
      // Only show toggle if there's a long list and we're on mobile
      if (hasLongList && this.isMobile()) {
        toggle.style.display = 'block';
      } else {
        toggle.style.display = 'none';
      }
      
      // Remove existing listener if any and add new one
      const newToggle = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newToggle, toggle);
      
      newToggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleList(wrapper, newToggle);
      });
    });
  }

  isMobile() {
    return window.innerWidth <= 899;
  }

  toggleList(wrapper, toggle) {
    const content = wrapper.querySelector('.collapsible-list-content');
    const lists = content.querySelectorAll('ul');
    const toggleText = toggle.querySelector('.collapsible-list-toggle-text');
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    
    lists.forEach(list => {
      const items = list.querySelectorAll('li');
      
      items.forEach((item, index) => {
        if (index >= 5) {
          if (isExpanded) {
            item.classList.add('collapsible-list-item-hidden');
          } else {
            item.classList.remove('collapsible-list-item-hidden');
          }
        }
      });
    });
    
    // Update toggle state
    toggle.setAttribute('aria-expanded', !isExpanded);
    toggleText.textContent = isExpanded 
      ? toggle.getAttribute('data-show-more-text') 
      : toggle.getAttribute('data-show-less-text');
  }
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.collapsibleList = new CollapsibleList();
  });
} else {
  window.collapsibleList = new CollapsibleList();
}

// Re-initialize for dynamic content (e.g., AJAX loaded content)
document.addEventListener('shopify:section:load', () => {
  window.collapsibleList = new CollapsibleList();
});

// Handle window resize to show/hide toggle based on screen size
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (window.collapsibleList) {
      window.collapsibleList.init();
    }
  }, 250);
});

